var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { attrs: { id: "dimmed-bg" } }, [
    _c("div", { attrs: { id: "popup-container" } }, [
      _c("div", {
        staticClass: "popup-text",
        domProps: { innerHTML: _vm._s(_vm.message) },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "check-button" } }, [
        _c("input", {
          staticClass: "red-btn-popup btn",
          attrs: {
            type: "button",
            value: _vm.l10.FindPassword_Ok_Popup_Button1,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("message", "")
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }